import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _createClass from "babel-runtime/helpers/createClass";
import { defer } from "rxjs";
import { filter, mapTo, publish, refCount } from "rxjs/operators";

var Handle = function () {
  function Handle(session, handle, qClass) {
    _classCallCheck(this, Handle);

    this.session = session;
    this.handle = handle;
    this.qClass = qClass;

    this.invalidated$ = session.changes$.pipe(filter(function (f) {
      return f.indexOf(handle) > -1;
    }), mapTo(this), publish(), refCount());
  }

  _createClass(Handle, [{
    key: "ask",
    value: function ask(method) {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return defer(function () {
        return _this.session.ask({
          method: method,
          handle: _this.handle,
          params: args.filter(function (arg) {
            return typeof arg !== "undefined";
          }),
          qClass: _this.qClass
        });
      });
    }
  }]);

  return Handle;
}();

export default Handle;